<template>
  <UFormGroup label="Departure date and time" name="date">
    <DatePicker
      v-model="date"
      mode="dateTime"
      :min-date="new Date()"
      :max-date="new Date().setFullYear(new Date().getFullYear() + 1)"
      :rules="{ minutes: [0, 15, 30, 45] }"
      timezone="Europe/Prague"
      hide-time-header
    />
    <p class="mb-0 text-sm text-gray-500 dark:text-gray-400">In the Central European Time zone.</p>
  </UFormGroup>
</template>

<script setup lang="ts">
import { DatePicker } from 'v-calendar'
import 'v-calendar/dist/style.css'
import { DateTime } from 'luxon'


const model = defineModel<string>()

const date = computed({
  get: () => model.value ? DateTime.fromISO(model.value).toJSDate() : undefined,
  set: (value: Date | undefined) => model.value = value ? DateTime.fromJSDate(value, { zone: 'Europe/Prague' }).toUTC().toISO()! : undefined,
})
</script>

<style scoped>
:deep(:root) {
  --vc-gray-50: rgb(var(--color-gray-50));
  --vc-gray-100: rgb(var(--color-gray-100));
  --vc-gray-200: rgb(var(--color-gray-200));
  --vc-gray-300: rgb(var(--color-gray-300));
  --vc-gray-400: rgb(var(--color-gray-400));
  --vc-gray-500: rgb(var(--color-gray-500));
  --vc-gray-600: rgb(var(--color-gray-600));
  --vc-gray-700: rgb(var(--color-gray-700));
  --vc-gray-800: rgb(var(--color-gray-800));
  --vc-gray-900: rgb(var(--color-gray-900));

  --vc-accent-50: rgb(var(--color-primary-50));
  --vc-accent-100: rgb(var(--color-primary-100));
  --vc-accent-200: rgb(var(--color-primary-200));
  --vc-accent-300: rgb(var(--color-primary-300));
  --vc-accent-400: rgb(var(--color-primary-400));
  --vc-accent-500: rgb(var(--color-primary-500));
  --vc-accent-600: rgb(var(--color-primary-600));
  --vc-accent-700: rgb(var(--color-primary-700));
  --vc-accent-800: rgb(var(--color-primary-800));
  --vc-accent-900: rgb(var(--color-primary-900));

  --vc-time-select-group-icon-color: var(--vc-gray-500);
  --vc-time-select-group-bg: transparent;
}
</style>
